export interface WorkflowStateModel {
  Id?: number | null;
  StateKey: string;
  Name: string;
  Description?: string;
  IsInitial: boolean;
  IsFinal: boolean;
  IsActive: boolean;
}

export interface WorkflowConditionModel {
  Id?: number | null;
  PropertyName: string;
  Operator: string;
  Value: string;
  ExecutionOrder: number;
}

export interface WorkflowTransitionModel {
  Id?: number | null;
  FromStateKey: string;
  ToStateKey: string;
  Name: string;
  Description?: string;
  IsManualTrigger: boolean;
  IsAutomaticTrigger: boolean;
  MinimumTimeInSourceState?: number;
  Priority: number;
  Conditions?: WorkflowConditionModel[];
}

// Operators available for conditions
export const CONDITION_OPERATORS = [
  { value: '==', label: 'Equals' },
  { value: '!=', label: 'Not Equals' },
  { value: '>', label: 'Greater Than' },
  { value: '<', label: 'Less Than' },
  { value: '>=', label: 'Greater Than or Equal' },
  { value: '<=', label: 'Less Than or Equal' },
  { value: 'contains', label: 'Contains' },
  { value: 'startswith', label: 'Starts With' },
  { value: 'endswith', label: 'Ends With' }
];

// Type for condition properties
export interface ConditionPropertyDefinition {
  value: string;
  label: string;
  type: 'string' | 'number' | 'boolean' | 'date';
}

// Fallback properties when no target-specific properties are provided
export const COMMON_CONDITION_PROPERTIES: ConditionPropertyDefinition[] = [
  { value: 'IsPaid', label: 'Is Paid', type: 'boolean' },
  { value: 'IsVoided', label: 'Is Voided', type: 'boolean' },
  { value: 'AmountDue', label: 'Amount Due', type: 'number' },
  { value: 'AmountPaid', label: 'Amount Paid', type: 'number' },
  { value: 'DaysSinceIssued', label: 'Days Since Issued', type: 'number' },
  { value: 'HasAppeal', label: 'Has Appeal', type: 'boolean' },
  { value: 'IsOverdue', label: 'Is Overdue', type: 'boolean' },
  { value: 'EscalationLevel', label: 'Escalation Level', type: 'number' }
];

export interface WorkflowModel {
  Id: number;
  TargetType: string;
  Name: string;
  Description?: string;
  IsActive: boolean;
  IsDefault: boolean;
  States: WorkflowStateModel[];
  Transitions: WorkflowTransitionModel[];
}

// Tree-based layout types
export interface TreeNode {
  state: WorkflowStateModel;
  children: TreeNode[];
  parent: TreeNode | null;
  depth: number;
  // Layout bounds - the horizontal space this node and its subtree occupy
  leftBound: number;
  rightBound: number;
  // Actual position
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface LayoutTransition {
  transition: WorkflowTransitionModel;
  fromNode: TreeNode;
  toNode: TreeNode;
  path: string;
  labelX: number;
  labelY: number;
  isBackward: boolean; // Loop back to earlier state
}

export interface DropZone {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  parentStateKey: string | null;
  insertIndex: number;
  label: string;
  isDisabled?: boolean;
}

export interface WorkflowLayout {
  nodes: TreeNode[];
  transitions: LayoutTransition[];
  dropZones: DropZone[];
  width: number;
  height: number;
}

export type SelectionType = 'state' | 'transition' | null;

export interface Selection {
  type: SelectionType;
  state?: WorkflowStateModel;
  transition?: WorkflowTransitionModel;
}
